import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import InputBoxLarge from '../../../components/common/InputBox/InputBoxLarge';
import TextBox from '../../../components/common/TextBox/TextBox';
import ErrorNotification from '../../../components/common/AlertBox/ErrorNotification';
import { SuccessAlert } from '../../../components/common/AlertBox/GreenAlert';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../components/common/CommonText.css';
import './PlanFeatures.css';
import { fetchFeatureById, editFeature } from '../../../services/planfeatures/Featuresapi';

const FeaturesEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({ name: '', description: '' });

    useEffect(() => {
        const load = async () => {
            const { data, error } = await fetchFeatureById(id);
            if (error === 1001) {
                navigate('/permission-denied');
            } else if (error) {
                setErrors({ general: 'Failed to load feature details.' });
            } else if (data) {
                setForm({ name: data.name || '', description: data.description || '' });
            }
            setLoading(false);
        };
        if (id) load();
    }, [id]);

    const handleChange = (key, value) => {
        setForm(prev => ({ ...prev, [key]: value }));
        setErrors(prev => { const e = { ...prev }; delete e[key]; return e; });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!form.name?.trim()) newErrors.name = ["Feature Name is required"];
        return newErrors;
    };

    const handleSubmit = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) { setErrors(validationErrors); return; }

        const { success, message } = await editFeature(id, form);

        if (success) {
            SuccessAlert("Feature updated successfully");
            navigate(`/features/detail/${id}`);
        } else {
            if (message && typeof message === 'object') {
                setErrors(message);
            } else {
                setErrors({ general: message || "Something went wrong" });
            }
        }
    };

    if (loading) return <div className="whole-container"><p className="common-text fts-14 ftw-4">Loading...</p></div>;

    return (
        <div className="whole-container">
            <div className="top-heading">
                <PageHeader
                    pageName="Plans / Features /"
                    nestedpageName="Edit Feature"
                    linkTo={`/features/detail/${id}`}
                />
            </div>

            <div className="page-container">
                <ErrorNotification errors={errors} marginBottom="16px" />

                <div className="card">
                    <div className="card-header">
                        <span className="card-title">Edit Feature</span>
                        <button
                            className="popup-add-button common-text white fts-15 ftw-5"
                            onClick={handleSubmit}
                        >
                            Save Changes
                        </button>
                    </div>

                    <div className="card-body">
                        <InputBoxLarge
                            label="Feature Name"
                            name="name"
                            defaultValue={form.name}
                            onChange={(e) => handleChange('name', e.target.value)}
                            isRequired
                            error={errors.name}
                        />
                        <TextBox
                            label="Description"
                            name="description"
                            defaultValue={form.description}
                            onChange={(e) => handleChange('description', e.target.value)}
                            error={errors.description}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturesEdit;